<template>


  <div class="container">
    <div class="row animate glow delay-1">
    <h1>Aufgabe 3.1</h1>
    <p>Stellen Sie sich vor: Sie sind Entwickler:in bei einem Lieferdienst für Essen. Ein neues Restaurant wurde in Ihre App. aufgenommen, und nun haben Sie die Aufgabe, eine <strong>Tabelle dafür zu erstellen</strong>. Das Restaurant <strong>heißt</strong> "Tacos Paradise" und besitzt eine <strong>ID</strong> als Primärschlüssel. Stellen Sie sicher, dass Sie auch das <strong>Email</strong>, die <strong>Postleitzahl (PLZ)</strong> den <strong>Typ</strong> und das <strong>Essen</strong>, die das Restaurant serviert, angeben.</p>
    </div>
    <div :class="['sql-input', { 'correct': isCorrect, 'incorrect': isIncorrect }]">
      <div v-if="!isCorrect && !isIncorrect">
        <span contenteditable="true" class="editable"></span>   <span contenteditable="true" class="editable"></span> tacos_paradise(ID INT
        <span contenteditable="true" class="editable"></span>, 
          <span contenteditable="true" class="editable"></span> VARCHAR(50), 
          <span contenteditable="true" class="editable"></span> INT,  
          <span contenteditable="true" class="editable"></span> VARCHAR(50),
         <span contenteditable="true" class="editable"></span> VARCHAR(50)
        );
      </div>
      <div v-if="isCorrect || isIncorrect" class="query-result">{{ resultMessage }}</div>
    </div>
    
    <div class="button-group">
      <button v-if="!isCorrect && !isIncorrect" type="button" class="submit-button" @click="handleSubmit">ABSCHICKEN</button>
      <button v-if="isIncorrect" type="button" class="repeat-button" @click="resetForm">WIEDERHOLEN</button>
      
    </div>
  </div>
  <div v-if="isTableCreated" class="new-table">
  <!-- This div should contain the structure of the new table you want to show -->
  <div class="database-table">
  <table>
    <thead>
      <tr>tacos_paradise</tr>
    <tr>
      <th>ID</th> <!-- New column for ID -->
      <th>email</th>
      <th>PLZ</th>
      <th>Typ</th>
      <th>Essen</th>
    </tr>
  </thead>
    <tbody>
      <!-- Add table rows and data here -->
    </tbody>
  </table>
</div>
</div>
  <div class="additional-box">
    {{ additionalMessage }}
  </div>
</template>



<script>
  import { onMounted } from 'vue'
  import store from "@/store.js"
  
  onMounted(() => {
    window.scrollTo(0, 0);
  })
export default {
  data() {
    return {
      resultMessage: '',
      numberMistakes: 0,
      correctQuery: "CREATE TABLE TACOS_PARADISE (ID INT PRIMARY KEY, EMAIL VARCHAR(50), PLZ INT, TYP VARCHAR(50), ESSEN VARCHAR(50));",
      isCorrect: false,
      isIncorrect: false,
      isTableCreated: false,
    };
  },
  mounted() {
    this.$emit('disableWeiter');
  },

  computed: {
    additionalMessage() {
    if (this.numberMistakes === 0) {
      return ''; // No mistakes yet, no message
    } else if (this.numberMistakes === 1) {
      return 'Ihre Lösung ist nicht korrekt, bitte versuchen Sie es erneut.';
    } else if (this.numberMistakes === 2) {
      return 'Erinnern Sie sich an die Schlüsselsyntax dieser SQL-Abfrage!';
    } else if (this.numberMistakes >= 3) {
      // Make sure to use the correctQuery from the data
      return `Die korrekte Lösung für diese Übung ist: ${this.correctQuery}`;
    
      
    }
    return ''; // This is a catch-all return to satisfy the rule that all paths must return a value
  }
},

  methods: {
    handleSubmit() {
  const queryParts = document.querySelectorAll('.editable');
  // Construct the user's query
  let userQuery = `${queryParts[0].innerText.trim()} ${queryParts[1].innerText.trim()} tacos_paradise (ID INT ${queryParts[2].innerText.trim()}, ${queryParts[3].innerText.trim()} VARCHAR(50), ${queryParts[4].innerText.trim()} INT,  ${queryParts[5].innerText.trim()} VARCHAR(50), ${queryParts[6].innerText.trim()} VARCHAR(50));`.toUpperCase();

  // Normalize the queries by removing extra spaces
  userQuery = userQuery.replace(/\s+/g, ' ').trim();
  const correctQuery = "CREATE TABLE TACOS_PARADISE (ID INT PRIMARY KEY, EMAIL VARCHAR(50), PLZ INT, TYP VARCHAR(50), ESSEN VARCHAR(50));".replace(/\s+/g, ' ').trim().toUpperCase();

  // Debugging: Log both queries to the console to compare
  console.log(`User Query: ${userQuery}`);
  console.log(`Correct Query: ${correctQuery}`);

  if (userQuery === correctQuery) {
    this.resultMessage = "Richtig! " + userQuery;
    this.isCorrect = true;
    this.isIncorrect = false;
    // Updated to ensure the additional message reflects the success state
    this.logCommit(this.numberMistakes)
    this.additionalMessage = 'Herzlichen Glückwunsch! Ihre Lösung ist korrekt.';
    this.isTableCreated = true;
    this.$emit('enableWeiter');
    // Reset numberMistakes as the answer is correct
    this.numberMistakes = 0;
  } else {
    this.resultMessage = `FEHLER - Ihre Eingabe war: ${userQuery}`;
    this.isCorrect = false;
    this.isIncorrect = true;
    this.isTableCreated = false;
    this.addMistake();
  }
},
addMistake() {
      // save number of mistakes
      this.numberMistakes++;
      if (this.numberMistakes === 1) {
        this.additionalMessage = 'Ihre Lösung ist nicht korrekt, bitte versuchen Sie es erneut.';
      } else if (this.numberMistakes === 2) {
        this.additionalMessage = 'Erinnern Sie sich an die Schlüsselsyntax dieser SQL-Abfrage!';
      } else if (this.numberMistakes > 2) {
        // Assuming this.correctAnswer contains the correct SQL query
        this.additionalMessage = `Die korrekte Lösung für diese Übung ist: ${this.correctQuery}`;
        
        this.isCorrect = false;
        this.isIncorrect = true;
      
        
      }
    },
    logCommit(numMist) {
      store.commit("databaseA31SaveMistakes", numMist);
    },
    resetForm() {
      this.resultMessage = '';
      this.additionalMessage = '';
      this.isCorrect = false;
      this.isIncorrect = false;
      //const queryParts = document.querySelectorAll('.editable');
    //queryParts.forEach(part => part.innerText = '');
    },
    goToNext() {
      console.log('Proceeding to the next step');
    }
  },
};
</script>

<style scoped>

p{
  line-height: 1.3;
}
.database-table table {
  width: 40%;
  border-collapse: collapse;
  text-align: left;
  margin-top: 30px;
  margin-left: auto;
  margin-right: 30px;
  
}

.database-table th,.database-table td {
  border: 1px solid #ddd;
  padding: 8px;

}

.database-table th {
  background-color: #f2f2f2;
}
.database-table thead {
  background-color: #bcbbbb;
  padding: 8px;
  text-align: left;
  font-style: italic;

}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin-top: 60px;
}

.assignment {
  width: 80%;
  margin: auto;
  text-align: left;
}

.sql-input {
  font-family: 'Courier New', Courier, monospace;
  margin-bottom: 10px;
  padding: 10px;
  border: 2px solid #ccc;
  box-sizing: border-box;
  transition: background-color 0.3s;
}

.editable {
  display: inline-block;
  min-width: 100px;
  margin: 0;
  padding: 2px;
  border-bottom: 1px solid #ccc;
  background-color: whitesmoke;
}

.query-result {
  text-align: center;
  width: 100%;
}

.correct {
  background-color: lightgreen;
}

.incorrect {
  background-color: lightcoral;
  color: white;
}

.button-group {
  display: flex;
  justify-content: flex-start;
}

.submit-button, .repeat-button, .next-button {
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
}

.submit-button, .repeat-button {
  background-color: #4CAF50;
  color: white;
}

.submit-button:hover, .repeat-button:hover {
  background-color: #45a049;
}

.next-button {
  background-color: #777777;
  color: rgb(74, 73, 73);
  margin-left: 10px;
}

.additional-box {
  width: 100%;
  margin: 10px auto;
  padding: 1px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  min-height: 100px;
  margin-top: 40px;
}


.button-active {
  background-color: #4CAF50; /* Or any other color for active state */
  color: white;
}

.next-button:disabled {
  background-color: #e7e7e7; /* Gray color for disabled state */
  color: rgb(123, 117, 117);
  cursor: not-allowed; /* Optional: Shows a 'not allowed' cursor */
}
</style>